import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FreegameBonusFactory } from "../FreegameBonus/FreegameBonus";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1 } from "../SlotGameType1";


// namespace SlotGames {

	export class RoyalChalice extends SlotGameType1 {		
		//protected override panelFactory:IPanelFactory = new RoyalChalicePanelFactory();
		//protected override helpFactory: IHelpFactory = new RoyalChaliceHelpFactory();
		
		//SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
		    coloroutherStroke: "black",
            colorinnerStroke: "darkred",
        }

		//LED COLOR
		protected override ColorLed:string="250,0,0\n";		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "RoyalChalice");
			this.spinnableReelsParams.topBorderWidth = 21;
			this.spinnableReelsParams.bottomBorderWidth = 13;
		}
	
	}


	//Panel Colorized
	class RoyalChalicePanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new RoyalChalicePanel(params);
		}
	}

	class RoyalChalicePanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors = {
				backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
			};
			return color;
			
		}

	}

	class RoyalChaliceHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new RoyalChaliceHelp(params);
        }
    }

    class RoyalChaliceHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
			let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(15,19,89),rgb(45,51,166), rgb(90,97,242),rgb(45,51,166),rgb(15,19,89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

	// class RoyalChaliceFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
	// 	{
	// 		return new RoyalChaliceFreegameBonus(gameName, params);
	// 	}
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new RoyalChaliceFreegamePickElement(params);
	// 	}
	// }
// }
